import { Grid } from "@mui/material";
import { ErrorMessage } from "formik";
import { useTranslation } from "react-i18next";

import Field from "../../component/Field";
import Label from "../../component/Label";
import { CommonUtil } from "../../util/Utils";
import SelectField from "../../component/SelectField";
import SameAsAbove from "../../component/sameAsAbove/SameAsAbove";

const query = require("india-pincode-search");

const ParentLinkParentInfo = (props: any) => {
  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    setFieldValue,
    countryOption,
  } = props;
  const { t } = useTranslation();

  const handleSwitchChange = (value: boolean) => {
    setFieldValue("sameAsAbove", value);
    if (setFieldValue) {
      if (value) {
        setFieldValue("whatsAppMobileNumber", values.primaryMobileNumber);
      } else {
        setFieldValue("whatsAppMobileNumber", "");
      }
    }
  };

  const onChangePincode = (e: any) => {
    setFieldValue("pinCode", e.target.value);
    let searchPinCode = query?.search(e.target.value);
    if (searchPinCode.length > 0) {
      setFieldValue("state", searchPinCode[0]?.state);
      setFieldValue("city", searchPinCode[0]?.city);
      setFieldValue("area", searchPinCode[0]?.office);
    } else {
      setFieldValue("state", null);
      setFieldValue("city", null);
      setFieldValue("area", null);
    }
  };

  return (
    <Grid
      container
      rowSpacing={1}
      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      style={{ padding: "10px" }}
    >
      <Grid item xs={12} sm={6} md={4} lg={4}>
        <div style={{ paddingRight: "20px" }}>
          <Label required title={t("primaryParentGuardianName")} />
          <Field
            name="parentName"
            placeholder={t("enterHere")}
            value={values.parentName}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.parentName && touched.parentName}
          />
          <div className="form-ele-gap inherit-number-field">
            <Label required title={t("primaryMobileNumber")} />
            <Field
              name="primaryMobileNumber"
              className="textFiled"
              value={values.primaryMobileNumber}
              onChange={handleChange}
              onBlur={handleBlur}
              type="number"
              onInput={(e: any) => CommonUtil.checkLengthHandler(e, 10)}
              helperText={<ErrorMessage name="primaryMobileNumber" />}
              error={errors.primaryMobileNumber && touched.primaryMobileNumber}
            />
          </div>
          <div style={{ textAlign: "right" }}>
            <SameAsAbove
              values={values}
              setFieldValue={setFieldValue}
              switchChange={handleSwitchChange}
            ></SameAsAbove>
          </div>
          <div className="form-ele-gap inherit-number-field">
            <Label required title={t("whatsAppMobileNumber")} />
            <Field
              name="whatsAppMobileNumber"
              disabled={values?.sameAsAbove}
              value={values.whatsAppMobileNumber}
              className="textFiled"
              type="number"
              onChange={handleChange}
              onBlur={handleBlur}
              onInput={(e: any) => CommonUtil.checkLengthHandler(e, 10)}
              helperText={<ErrorMessage name="whatsAppMobileNumber" />}
              error={
                errors.whatsAppMobileNumber && touched.whatsAppMobileNumber
              }
            />
          </div>

          <Label required title={t("email")} />
          <Field
            className="textFiled"
            name="email"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            helperText={<ErrorMessage name="email" />}
            error={errors.email && touched.email}
          />
        </div>
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={4}>
        <div>
          <div>
            <Label title={t("country")} />
            <SelectField
              name="country"
              style={{ width: "100%" }}
              value={values.countryId || t("select")}
              onChange={handleChange}
              onBlur={handleBlur}
              options={countryOption}
              error={errors.country && touched.country}
            />
          </div>
          <div className="form-ele-gap inherit-number-field">
            <Label required title={t("pinCode")} />
            <Field
              type="number"
              name="pinCode"
              placeholder={t("enterHere")}
              value={values.pinCode}
              onInput={(e: any) => CommonUtil.checkLengthHandler(e, 6)}
              onChange={(e: any) => {
                onChangePincode(e);
                handleChange(e);
              }}
              onBlur={handleBlur}
              error={errors.pinCode && touched.pinCode}
            />
          </div>
        </div>
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={4}>
        <div>
          <Label title={t("state")} />
          <Field
            className="textFiled"
            disabled
            name="state"
            placeholder={t("stateName")}
            value={values.state}
            onChange={handleChange}
            onBlur={handleBlur}
            helperText={<ErrorMessage name="state" />}
            error={errors.entityName && touched.state}
          />
          <div className="form-ele-gap">
            <Label title={t("city")} />
            <Field
              className="textFiled"
              disabled
              name="city"
              placeholder={t("cityName")}
              value={values.city}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={<ErrorMessage name="city" />}
              error={errors.city && touched.city}
            />
          </div>
          <div className="form-ele-gap">
            <Label title={t("area")} />
            <Field
              className="textFiled"
              name="area"
              placeholder={t("areaName")}
              disabled
              value={values.area}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={<ErrorMessage name="area" />}
              error={errors.area && touched.area}
            />
          </div>
          <div className="form-ele-gap">
            <Label title={t("address")} />
            <Field
              type="textarea"
              placeholder={t("enterHere")}
              multiline
              rows={2}
              className="textFiled"
              name="address"
              value={values.address}
              onChange={handleChange}
              onBlur={handleBlur}
              helperText={<ErrorMessage name="address" />}
              error={errors.address && touched.address}
            />
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default ParentLinkParentInfo;
